import * as gochiEventSettingActions from '../actions/GochiEventSetting';

const initialState = {
  list: [],
  dataByMenu: {
    list: [],
    menuEventId: 0,
    menuEventName: '',
    status: 0
  }
};

const gochiEventSetting = (state = initialState, action) => {
  switch (action.type) {
    case gochiEventSettingActions.GET_GOCHI_EVENT_SETTING_SUCCESS:
      return Object.assign({}, state, action.payload);
    case gochiEventSettingActions.GET_GOCHI_EVENT_SETTING_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case gochiEventSettingActions.GET_GOCHI_EVENT_SETTING_BY_MENU_SUCCESS:
      return {
        ...state,
        dataByMenu: action.payload
      };
    case gochiEventSettingActions.GET_GOCHI_EVENT_SETTING_BY_MENU_FAILURE:
      return {
        ...state,
        dataByMenu: {
          ...state.dataByMenu,
          status: action.payload,
          error: action.error
        }
      };
    default:
      return state;
  }
};

export default gochiEventSetting;
